/* eslint-disable */
//
import { Component } from "react"
import PropTypes from "prop-types"

import isFeatureEnabled from "shared/featureflags/helperFunctions"

import { createOrderByFilterGroup, genericFilterGroup } from "shared/search/containers/FilterGroup/FilterGroups"
import { createCustomFilterGroup } from "shared/search/containers/FilterGroup/CustomFilterGroup"

import {
    RegionFilter,
    RegionCountryFilter,
    RegionCountryEUFilter,
    DateListFilter,
    DateListNoPastFilter,
    createListFilter,
    createNotInListFilter,
    ManuallyChangedInListFilter,
} from "shared/search/containers/Filter/Filters"

import {
    NoteAmendmentMentionFilter,
    NoteArticleMentionFilter,
    NoteAttachmentTypeFilter,
    NoteBillMentionFilter,
    NoteCheckFilter,
    NoteCheckNumberFilter,
    NoteCommentTypeFilter,
    NoteCreatedDateListFilter,
    NoteCreatedEndDateFilter,
    NoteCreatedStartDateFilter,
    NoteCreatorFilter,
    NoteDonationFilter,
    NoteDonationTypeFilter,
    NoteEndDateFilter,
    NoteInIssueFilter,
    NoteInteractionTypeFilter,
    NoteInvolvingCurrentUserOrTeamFilter,
    NoteInvolvingMemberFilter,
    NoteInvolvingOfficeFilter,
    NoteInvolvingOfficialsAndStaffersFilter,
    NoteInvolvingOrganizationFilter,
    NoteInvolvingParticipantsTripletFilter,
    NoteInvolvingPressContactFilter,
    NoteInvolvingStafferFilter,
    NoteInvolvingSupporterFilter,
    NoteInvolvingUserFilter,
    NoteMentionsUserFilter,
    NoteNotInIssueFilter,
    NoteRelationshipStatusFilter,
    NoteRelationshipTypeFilter,
    NoteSourceTypeFilter,
    NoteStartDateFilter,
    NoteTypeFilter,
    NoteUserOrganizationFilter,
    NoteVoteMentionFilter,
    // Organization profile
    NoteOrganizatonsFilter,
    NoteDurationFilter,
} from "shared/search/containers/Filter/NoteFilters"

const defaultProps = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}

export const NoteCustomFilterGroup = createCustomFilterGroup(
    "noteCustomFilterGroup",
    DjangIO.app.models.QuorumDataType.note.value,
)

export class NoteTypeFilterGroup extends Component {
    static defaultProps = {
        filters: [
            NoteTypeFilter,
            NoteInteractionTypeFilter,
            NoteRelationshipTypeFilter,
            NoteCommentTypeFilter,
            NoteDonationTypeFilter,
            NoteRelationshipStatusFilter,
            NoteAttachmentTypeFilter,
        ],
        uniqueFilterGroupId: "noteTypeFilterGroup",
        displayLabel: "Note Type",
        helpText:
            "Filter notes by interactions or comments, " + "type of correspondence or event, or grassroots action.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class NoteInteractionTypeFilterGroup extends Component {
    static defaultProps = {
        filters: [NoteInteractionTypeFilter, NoteDonationTypeFilter, NoteAttachmentTypeFilter],
        uniqueFilterGroupId: "noteTypeFilterGroup",
        displayLabel: "Note Type",
        helpText: "Filter notes by interactions or grassroots action.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class NoteSourceFilterGroup extends Component {
    static defaultProps = {
        filters: [NoteSourceTypeFilter],
        uniqueFilterGroupId: "noteSourceFilterGroup",
        displayLabel: "Note Source",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class NoteInvolvingFilterGroup extends Component {
    static defaultProps = {
        filters: [
            NoteInvolvingCurrentUserOrTeamFilter,
            NoteInvolvingOfficeFilter,
            NoteInvolvingOfficialsAndStaffersFilter,
            // global includes us regions, so we cannot rely on regions prop on the filter to determine if we should show it
            ...(Userdata.current_regions.includes(DjangIO.app.models.SupportedRegion.user_global.abbrev)
                ? []
                : [NoteInvolvingMemberFilter, NoteInvolvingStafferFilter]),
            NoteInvolvingPressContactFilter,
            NoteInvolvingSupporterFilter,
            NoteInvolvingOrganizationFilter,
            NoteInvolvingUserFilter,
            NoteCreatorFilter,
            NoteInvolvingParticipantsTripletFilter,
        ],
        uniqueFilterGroupId: "noteInvolvingFilterGroup",
        displayLabel: "Participants",
        helpText:
            "Filter notes by participants, supporters, organizations, and members " +
            "of your organization. To see all interactions with a given legislator and " +
            "their staff, choose the legislator as the participant and notes related to all " +
            "current and former staffers will be shown as well.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class NoteStartDateFilterGroup extends Component {
    static defaultProps = {
        filters: [DateListFilter, NoteStartDateFilter, NoteEndDateFilter],
        uniqueFilterGroupId: "noteStartDateFilterGroup",
        displayLabel: "Note Start Date",
        helpText:
            "Filter Notes by a date range in which they will take place or already occurred, " +
            "or within a specific from and to date",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class NoteStartDateNoPastFilterGroup extends Component {
    static defaultProps = {
        filters: [DateListNoPastFilter, NoteStartDateFilter, NoteEndDateFilter],
        uniqueFilterGroupId: "noteStartDateFilterGroup",
        displayLabel: "Note Start Date",
        helpText:
            "Filter Notes by a date range in which they will take place or already occurred, " +
            "or within a specific from and to date",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class NoteCreatedDateFilterGroup extends Component {
    static defaultProps = {
        filters: [NoteCreatedDateListFilter, NoteCreatedStartDateFilter, NoteCreatedEndDateFilter],
        uniqueFilterGroupId: "noteCreatedDateFilterGroup",
        displayLabel: "Note Created Date",
        helpText: "Filter Notes by a date range in which it was created, or within a specific from and to date.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class NoteRegionFilterGroup extends Component {
    static defaultProps = {
        filters: [RegionFilter, RegionCountryFilter, RegionCountryEUFilter],
        uniqueFilterGroupId: "noteRegionFilterGroup",
        displayLabel: "Region",
        helpText: "Filter results from a single region or groups of regions.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export const NoteProjectFilterGroup = (props) => genericFilterGroup(props)
NoteProjectFilterGroup.propTypes = defaultProps
NoteProjectFilterGroup.defaultProps = {
    filters: [NoteInIssueFilter, NoteNotInIssueFilter],
    uniqueFilterGroupId: "noteProjectFilterGroup",
    displayLabel: "Issues",
    helpText: "Filter results by the issue they are tagged to.",
}

export class NoteMentionFilterGroup extends Component {
    static defaultProps = {
        filters: [
            NoteBillMentionFilter,
            NoteVoteMentionFilter,
            NoteAmendmentMentionFilter,
            NoteArticleMentionFilter,
            NoteMentionsUserFilter,
        ],
        uniqueFilterGroupId: "noteMentionFilterGroup",
        displayLabel: "Referencing",
        helpText: "Filter notes by comments that you’ve made on a specific bill, vote, " + "amendment, and/or article.",
        permissions: [
            DjangIO.app.models.PermissionType.legislators,
            DjangIO.app.models.PermissionType.executives,
            DjangIO.app.models.PermissionType.staffers,
        ],
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class NoteListFilterGroup extends Component {
    static defaultProps = {
        filters: [
            createListFilter(DjangIO.app.models.QuorumDataType.note.value),
            createNotInListFilter(DjangIO.app.models.QuorumDataType.note.value),
            ManuallyChangedInListFilter,
        ],
        uniqueFilterGroupId: "noteListFilterGroup",
        displayLabel: "Lists",
        helpText: "Filter notes by your lists to show notes you've saved to Projects.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class NoteInvisibleFilterGroup extends Component {
    static defaultProps = {
        filters: [NoteUserOrganizationFilter],
        uniqueFilterGroupId: "noteInvisibleFilterGroup",
        invisible: true,
    }
}

export const NoteOrganizationProfileFilterGroup = (props) => genericFilterGroup(props)
NoteOrganizationProfileFilterGroup.propTypes = defaultProps
NoteOrganizationProfileFilterGroup.defaultProps = {
    filters: [NoteOrganizatonsFilter],
    uniqueFilterGroupId: "noteOrganizationProfileFilterGroup",
    noHeader: true,
    alwaysOpen: true,
}

export class NoteDurationFilterGroup extends Component {
    static defaultProps = {
        filters: [NoteDurationFilter],
        uniqueFilterGroupId: "noteDurationFilterGroup",
        displayLabel: "Duration",
        helpText: "Filter results based on the duration of the note.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class NoteDonationFilterGroup extends Component {
    static defaultProps = {
        filters: [NoteDonationFilter, NoteCheckNumberFilter, NoteCheckFilter],
        uniqueFilterGroupId: "noteDonationFilterGroup",
        displayLabel: "Donations",
        helpText: "Filter results based on the donation amount or check number of the note.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export const NoteOrderByFilterGroup = createOrderByFilterGroup({
    // uniqueFilterId = "noteOrderBy"
    quorumDataType: DjangIO.app.models.QuorumDataType.note.value,
})
